module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/event_personal-f352b1688c25076d27ff717c4b0c7169.jpg";